import { Component, Inject, ViewChild, TemplateRef } from '@angular/core';
import { DOCUMENT } from '@angular/common';

import { MatDatepicker, MatDatepickerToggle } from '@angular/material/datepicker';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';

import { Observable } from 'rxjs';
import { environment as env } from '@env/environment';
//import { ServiceService } from '@app/core/services/ServiceService';
import { AuthenticationService } from '@app/core/services/AuthenticationService'
import { ICompany } from '@app/core/interfaces/ICompany';
//import { InvoiceService } from '@app/core/services/InvoiceService';
import { CompanyService } from '@app/core/services/CompanyService';


@Component({
  standalone: false,
    selector: 'edit-customer-dialog',
    templateUrl: 'invoice-tool.invoicePreviewDialog.Component.html'
})


export class InvoicePreviewDialogComponent {
    private _dimesionToggle = false;
    private _formValid = false;
    public _imageList: any[] = [];
    public _hasImages = false;
    private _showImageList = false;
    private _showAttachments = false;
    private _hasAttachments = false;
    private _showComments = false;
    public customer: ICompany;
    public isNewCustomer: boolean;
    public logo = env.logoUrl || 'assets/logo.png';
    @ViewChild('myInput', { static: false })
    myInputVariable: any;
    private _apiBaseUrl: string;
    @ViewChild("datepicker", { static: false }) datepicker: MatDatepicker<Date>;
    selectedDate: Date = new Date();
    //private invoiceItemGroup = {InvoiceRows:[]};
    private hoursList = [];
    private vatList = [];
    private rowTypeList = [];
    private hoursSelected: string = "8";
    private vatSelected: string = "25";
    private rowTypeSelected: string = "0"
    private row: any = {};

    public today: Date = new Date();

    constructor(
        public dialogRef: MatDialogRef<InvoicePreviewDialogComponent>,
        //private service: ServiceService,
        private authenticationService: AuthenticationService,
        //private invoiceService: InvoiceService,
        private companyService: CompanyService,
        //private config: AppConfig,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) 
    { 
        //this._apiBaseUrl = config.getConfig('host');
    }

    ngOnInit() {

    console.log(this.data);

        // Create new group
    //    if (this.data.invoiceItemGroup == undefined)
    //    {
    //        this.data.invoiceItemGroup = { Id: this.guid(), Description: '', InvoiceRows: [], Type: {}};
    //    }

    //    this.data.invoiceItemGroup = JSON.parse(JSON.stringify(this.data.invoiceItemGroup));


    //    if (this.data.invoiceItemGroup.InvoiceRows != undefined) {
    //        for (var i = 0; i < this.data.invoiceItemGroup.InvoiceRows.length; i++) {
    //            this.data.invoiceItemGroup.InvoiceRows[i].HoursWorked = this.data.invoiceItemGroup.InvoiceRows[i].HoursWorked.toString();
    //        }
    //    }

    //    this.hoursList.push({ Value: "8" }, { Value: "7.5" }, { Value: "7" }, { Value: "6.5" }, { Value: "6" }, { Value: "5.5" }, { Value: "5" }, { Value: "4.5" }, { Value: "4" }, { Value: "3.5" }, { Value: "3" }, { Value: "2.5" }, { Value: "2" }, { Value: "1.5" }, { Value: "1" }, { Value: "0.5" });
    //    this.vatList.push({ Value: "25" }, { Value: "6" }, { Value: "0" })
    //    this.rowTypeList.push({ Value: "1", Name: "Arbetad tid" }, { Value: "2", Name: "Övrigt" })
    }

    rowTypeChange(event: any)
    {
        this.data.invoiceItemGroup.Type = this.getRowType(event.value);
        
        if (event.value == "Övrigt")
        {
            // No rows allowed in the misc category
            this.data.invoiceItemGroup.InvoiceRows = [];
        }
    }

    // Helpers for preview calculations
    private parseDate(value: any): Date | null {
        try {
            if (!value) { return null; }
            const d = new Date(value);
            return isNaN(d.getTime()) ? null : d;
        } catch { return null; }
    }
    getSubtotalExclVat(): number {
        try {
            let subtotal = 0;
            if (this.data && Array.isArray(this.data.InvoiceGroups)) {
                // Determine if allowances/deductions are grouped
                const groups = this.data.InvoiceGroups || [];
                const hasGroupedAllowances = groups.some((gg: any) => Array.isArray(gg && gg.Allowances) && gg.Allowances.length > 0);
                const hasGroupedDeductions = groups.some((gg: any) => Array.isArray(gg && gg.Deductions) && gg.Deductions.length > 0);
                for (const g of groups) {
                    // Base group amount
                    subtotal += Number(g && g.Amount) || 0;
                    // Added-to-invoice deductions
                    if (Array.isArray((g as any).Deductions)) {
                        for (const d of (g as any).Deductions) {
                            if (d && d.AddedToInvoice === true) {
                                subtotal += this.getDeductionBilledAmount(d);
                            }
                        }
                    }
                    // Added-to-invoice allowances
                    if (Array.isArray((g as any).Allowances)) {
                        for (const a of (g as any).Allowances) {
                            if (a && a.AddedToInvoice === true) {
                                subtotal += this.getAllowanceBilledAmount(a);
                            }
                        }
                    }
                }
                // Include top-level deductions if not grouped
                if (!hasGroupedDeductions && Array.isArray((this.data as any).Deductions)) {
                    for (const d of (this.data as any).Deductions) {
                        if (d && d.AddedToInvoice === true) { subtotal += this.getDeductionBilledAmount(d); }
                    }
                }
                // Include top-level allowances if not grouped
                if (!hasGroupedAllowances && Array.isArray((this.data as any).Allowances)) {
                    for (const a of (this.data as any).Allowances) {
                        if (a && a.AddedToInvoice === true) { subtotal += this.getAllowanceBilledAmount(a); }
                    }
                }
            }
            // Add invoice fee (excl. VAT) if applicable
            subtotal += this.getInvoiceFeeExclVat();
            return subtotal;
        } catch { }
        return 0;
    }

    getVatTotal(): number {
        try {
            let totalVat = 0;
            if (this.data && Array.isArray(this.data.InvoiceGroups)) {
                const groups = this.data.InvoiceGroups || [];
                const hasGroupedAllowances = groups.some((gg: any) => Array.isArray(gg && gg.Allowances) && gg.Allowances.length > 0);
                const hasGroupedDeductions = groups.some((gg: any) => Array.isArray(gg && gg.Deductions) && gg.Deductions.length > 0);
                for (const g of groups) {
                    const base = Number(g && g.Amount) || 0;
                    const vatRate = (Number(((g as any) && (g as any).Vat)) || 0) / 100;
                    totalVat += base * vatRate;
                    // Deductions VAT
                    if (Array.isArray((g as any).Deductions)) {
                        for (const d of (g as any).Deductions) {
                            if (d && d.AddedToInvoice === true) {
                                const dBase = this.getDeductionBilledAmount(d);
                                const dVatRate = (Number(d.VatPercentage) || 0) / 100;
                                totalVat += dBase * dVatRate;
                            }
                        }
                    }
                    // Allowances VAT
                    if (Array.isArray((g as any).Allowances)) {
                        for (const a of (g as any).Allowances) {
                            if (a && a.AddedToInvoice === true) {
                                const aBase = this.getAllowanceBilledAmount(a);
                                const aVatRate = (Number(a.VatPercentage) || 0) / 100;
                                totalVat += aBase * aVatRate;
                            }
                        }
                    }
                }
                // Top-level only if not grouped
                if (!hasGroupedDeductions && Array.isArray((this.data as any).Deductions)) {
                    for (const d of (this.data as any).Deductions) {
                        if (d && d.AddedToInvoice === true) {
                            const dBase = this.getDeductionBilledAmount(d);
                            const dVatRate = (Number(d.VatPercentage) || 0) / 100;
                            totalVat += dBase * dVatRate;
                        }
                    }
                }
                if (!hasGroupedAllowances && Array.isArray((this.data as any).Allowances)) {
                    for (const a of (this.data as any).Allowances) {
                        if (a && a.AddedToInvoice === true) {
                            const aBase = this.getAllowanceBilledAmount(a);
                            const aVatRate = (Number(a.VatPercentage) || 0) / 100;
                            totalVat += aBase * aVatRate;
                        }
                    }
                }
            }
            // Invoice fee VAT
            totalVat += this.getInvoiceFeeVat();
            return totalVat;
        } catch { }
        return 0;
    }

    getTotalInclVat(): number {
        return this.getSubtotalExclVat() + this.getVatTotal();
    }

    // Invoice fee helpers
    private isSwedishCustomer(): boolean {
        try {
            const countryName = (this.data && this.data.Customer && this.data.Customer.Country && this.data.Customer.Country.Name) ? this.data.Customer.Country.Name.toString().toLowerCase() : '';
            if (!countryName) { return true; } // Default to Swedish if not specified
            return countryName === 'sverige' || countryName === 'sweden';
        } catch { return true; }
    }

    private shouldApplyInvoiceFee(): boolean {
        try {
            const byCustomer = !!(this.data && (this.data.InvoiceFeePaidByCustomer === true || this.data.FeePaidByReciever === true));
            return !!(byCustomer && Number(this.data.InvoiceFee) > 0 && this.isSwedishCustomer());
        } catch { return false; }
    }

    private getInvoiceFeeExclVat(): number {
        try {
            if (this.shouldApplyInvoiceFee()) {
                return Number(this.data.InvoiceFee) || 0;
            }
        } catch { }
        return 0;
    }

    private getInvoiceFeeVat(): number {
        try {
            if (this.shouldApplyInvoiceFee()) {
                const fee = Number(this.data.InvoiceFee) || 0;
                const providedVat = (this.data as any).InvoiceFeeVat;
                if (typeof providedVat === 'number') { return providedVat; }
                // Default VAT rate for invoice fee: 25%
                return fee * 0.25;
            }
        } catch { }
        return 0;
    }

    getInvoiceFeeDisplay(): number {
        return this.getInvoiceFeeExclVat();
    }

    // Cash rounding (öresavrundning) to nearest whole krona: 0-49 öre down, 50-99 up
    getRoundingAdjustment(): number {
        const raw = this.getTotalInclVat();
        // Round to nearest whole SEK using .5 up rule
        const rounded = Math.round(raw);
        // Adjustment to apply to reach rounded amount
        const diff = rounded - raw;
        // Keep two decimals precision for display
        return Math.round(diff * 100) / 100;
    }

    getRoundedPayTotal(): number {
        const total = this.getTotalInclVat();
        const adj = this.getRoundingAdjustment();
        return total + adj;
    }

    // Helpers to detect if items are attached per group
    hasGroupedAllowances(): boolean {
        try {
            const groups = (this.data && Array.isArray(this.data.InvoiceGroups)) ? this.data.InvoiceGroups : [];
            return groups.some((g: any) => Array.isArray(g && g.Allowances) && g.Allowances.length > 0);
        } catch { return false; }
    }
    hasGroupedDeductions(): boolean {
        try {
            const groups = (this.data && Array.isArray(this.data.InvoiceGroups)) ? this.data.InvoiceGroups : [];
            return groups.some((g: any) => Array.isArray(g && g.Deductions) && g.Deductions.length > 0);
        } catch { return false; }
    }

    getDueDate(): Date | null {
        try {
            const termStr = this.data && this.data.PaymentTerm ? this.data.PaymentTerm.toString() : '0';
            const term = parseInt(termStr, 10);
            if (!isNaN(term)) {
                const d = new Date(this.today);
                d.setDate(d.getDate() + term);
                return d;
            }
        } catch { }
        return null;
    }

    //setRow()
    //{
    //    this.row.totalAmount = this.data.invoiceItemGroup.totalAmount;
    //    this.row.description = this.data.invoiceItemGroup.description;
    //    this.row.vat = this.data.invoiceItemGroup.InvoiceRows[0].vat;
    //}

    getRowType(id: any)
    {
        for (var i = 0; i < this.rowTypeList.length; i++)
        {
            if (this.rowTypeList[i].Name == id)
            {
                return this.rowTypeList[i];
            }
        }
    }

    saveCalendar()
    {
        this.dialogRef.close(this.data.invoiceItemGroup);
    }

    saveRow() {
        this.dialogRef.close(this.data.invoiceItemGroup);
    }
  
    deleteRow()
    {
        this.data.invoiceItemGroup.action = 'delete';
        this.dialogRef.close(this.data.invoiceItemGroup);
    }    

    cancel()
    {
        this.dialogRef.close(undefined);
    }
    
    deleteListItem(item: any)
    {
        this.data.invoiceItemGroup.InvoiceRows.splice(this.data.invoiceItemGroup.InvoiceRows.indexOf(item), 1);
    }

    guid() {  
        return this.s4() + this.s4() + '-' + this.s4() + '-' + this.s4() + '-' + this.s4() + '-' + this.s4() + this.s4() + this.s4();
    }

    s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }
    
    calendarSelect(event: any)
    {
        var date = event.toLocaleDateString();
        this.data.invoiceItemGroup.InvoiceRows.push({ StartDate: date, Id: this.guid(), HoursWorked: this.hoursSelected, Vat: this.vatSelected });
    }
    
    onError(error: any)
    {
        alert('An error occured');
        console.log(error);
    }
    
    // Returns array with VAT breakdown per rate: [{ vat, vatAmount, base }]
    getVatBreakdown(): Array<{ vat: number, vatAmount: number, base: number }> {
        const map: any = {};
        if (this.data && Array.isArray(this.data.InvoiceGroups)) {
            const groups = this.data.InvoiceGroups || [];
            const hasGroupedAllowances = groups.some((gg: any) => Array.isArray(gg && gg.Allowances) && gg.Allowances.length > 0);
            const hasGroupedDeductions = groups.some((gg: any) => Array.isArray(gg && gg.Deductions) && gg.Deductions.length > 0);
            for (const g of groups) {
                // Groups
                const base = Number(g.Amount) || 0;
                const vat = Number(g.Vat) || 0;
                if (!map[vat]) { map[vat] = { vat, vatAmount: 0, base: 0 }; }
                map[vat].base += base;
                map[vat].vatAmount += base * (vat / 100);
                // Deductions
                if (Array.isArray((g as any).Deductions)) {
                    for (const d of (g as any).Deductions) {
                        if (d && d.AddedToInvoice === true) {
                            const dBase = this.getDeductionBilledAmount(d);
                            const dVat = Number(d.VatPercentage) || 0;
                            if (!map[dVat]) { map[dVat] = { vat: dVat, vatAmount: 0, base: 0 }; }
                            map[dVat].base += dBase;
                            map[dVat].vatAmount += dBase * (dVat / 100);
                        }
                    }
                }
                // Allowances
                if (Array.isArray((g as any).Allowances)) {
                    for (const a of (g as any).Allowances) {
                        if (a && a.AddedToInvoice === true) {
                            const aBase = this.getAllowanceBilledAmount(a);
                            const aVat = Number(a.VatPercentage) || 0;
                            if (!map[aVat]) { map[aVat] = { vat: aVat, vatAmount: 0, base: 0 }; }
                            map[aVat].base += aBase;
                            map[aVat].vatAmount += aBase * (aVat / 100);
                        }
                    }
                }
            }
            // Top-level only if not grouped
            if (!hasGroupedDeductions && Array.isArray((this.data as any).Deductions)) {
                for (const d of (this.data as any).Deductions) {
                    if (d && d.AddedToInvoice === true) {
                        const dBase = this.getDeductionBilledAmount(d);
                        const dVat = Number(d.VatPercentage) || 0;
                        if (!map[dVat]) { map[dVat] = { vat: dVat, vatAmount: 0, base: 0 }; }
                        map[dVat].base += dBase;
                        map[dVat].vatAmount += dBase * (dVat / 100);
                    }
                }
            }
            if (!hasGroupedAllowances && Array.isArray((this.data as any).Allowances)) {
                for (const a of (this.data as any).Allowances) {
                    if (a && a.AddedToInvoice === true) {
                        const aBase = this.getAllowanceBilledAmount(a);
                        const aVat = Number(a.VatPercentage) || 0;
                        if (!map[aVat]) { map[aVat] = { vat: aVat, vatAmount: 0, base: 0 }; }
                        map[aVat].base += aBase;
                        map[aVat].vatAmount += aBase * (aVat / 100);
                    }
                }
            }
        }
        // Include invoice fee in VAT breakdown if applicable
        const feeBase = this.getInvoiceFeeExclVat();
        if (feeBase > 0) {
            // Determine VAT rate for fee
            let feeVatRate = 25;
            const providedVat = (this.data as any).InvoiceFeeVat;
            if (typeof providedVat === 'number' && feeBase > 0) {
                const rate = Math.round((providedVat / feeBase) * 100);
                if (!isNaN(rate)) { feeVatRate = rate; }
            }
            if (!map[feeVatRate]) { map[feeVatRate] = { vat: feeVatRate, vatAmount: 0, base: 0 }; }
            map[feeVatRate].base += feeBase;
            map[feeVatRate].vatAmount += feeBase * (feeVatRate / 100);
        }
        return Object.keys(map).map(k => map[k]).filter(x => x.base > 0);
    }

    // Calculate billed amount for an allowance (handles mileage custom reimbursement)
    getDeductionBilledAmount(d: any): number {
        return Number(d && d.AgreedInvoiceAmount != null ? d.AgreedInvoiceAmount : d && d.Amount) || 0;
    }

    getAllowanceBilledAmount(a: any): number {
        try {
            if (!a) { return 0; }
            const isMileage = a && a.AllowanceType && (a.AllowanceType.Id === 1 || a.AllowanceType.Id === '1');
            if (isMileage && a.CustomReimbursementPerKm && a.CustomReimbursementPerKm !== 0 && a.sumCustomReimbursementPerKm) {
                return Number(a.sumCustomReimbursementPerKm) || 0;
            }
            return Number(a.Sum) || 0;
        } catch { return 0; }
    }

    // Summarize a group's date range and hours
    getGroupSummary(g: any): { from?: Date, to?: Date, hours?: number } {
        const res: any = { hours: 0 };
        if (!g || !Array.isArray(g.InvoiceRows) || g.InvoiceRows.length === 0) { return res; }
        const dates: Date[] = [];
        for (const r of g.InvoiceRows) {
            const d = this.parseDate(r.StartDate);
            if (d) { dates.push(d); }
            const h = Number(r.HoursWorked);
            if (!isNaN(h)) { res.hours += h; }
        }
        if (dates.length > 0) {
            dates.sort((a,b) => a.getTime() - b.getTime());
            res.from = dates[0];
            res.to = dates[dates.length - 1];
        }
        return res;
    }

    // Match invoice-admin formatting: total time as "X h Y min" (or "X h")
    getGroupTotalHours(group: any): string {
        if (!group || !Array.isArray(group.InvoiceRows)) { return '0 h'; }
        let totalMinutes = 0;
        for (const row of group.InvoiceRows) {
            const hours = parseInt((row && row.HoursWorked) ? row.HoursWorked : 0, 10) || 0;
            const minutes = parseInt((row && row.MinutesWorked) ? row.MinutesWorked : 0, 10) || 0;
            totalMinutes += hours * 60 + minutes;
        }
        return this.time_convert(totalMinutes);
    }

    private time_convert(totalMinutes: number): string {
        const hours = Math.floor(totalMinutes / 60);
        const minutes = totalMinutes % 60;
        if (minutes > 0) {
            return `${hours} h ${minutes} min`;
        }
        return `${hours} h`;
    }

    isWorkedHoursGroup(group: any): boolean {
        const tech = group && group.Type ? String(group.Type.TechnicalName || '') : '';
        if (tech === 'WorkedHours') { return true; }

        const name = group && group.Type ? String(group.Type.Name || '').toLowerCase() : '';
        if (name === 'arbetad tid') { return true; }

        const description = group ? String(group.Description || '').toLowerCase() : '';
        if (description === 'arbetad tid') { return true; }

        const rows = group && Array.isArray(group.InvoiceRows) ? group.InvoiceRows : [];
        const amount = Number(group && group.Amount || 0);
        return rows.length > 0 && amount === 0;
    }

}



